<template>
  <div class="custom-main custom-theme" style="margin: 0px;">
    <audio preload="load" id="voice">
      <source src="../../../assets/audio/telemed.mp3" type="audio/mp3" />
    </audio>
    <a-spin :spinning="loading" :tip="loadTip">
      <a-row>
        <a-col :xxl="16" :xl="16" :lg="16" :md="24" :sm="24" :xs="24">
          <template v-for="(item, index) in (records||[])">
            <a-card :key="'t-'+index" size="small" :bordered="false"
                    :body-style="{'borderBottom':'1px solid rgba(224, 224, 224, 1)'}">
              <a-row>
                <a-col span="22">
                  <a-row>
                    <a-col span="4" style="line-height: 32px;margin-bottom: 6px;">
                      <div v-if="(item.status == 'C_ACCEPTED' || item.status == 'D_VISITING')"
                           style="text-align:center;width: 100px;height: 32px;border:1px solid rgba(63, 164, 99, 0.23);border-radius: 17px;margin-left:12px;font-size: 16px;font-family: Alibaba PuHuiTi;font-weight: 400;color: #56AB1F;">
                        已预约
                      </div>
                      <div v-else style="text-align:center;width: 100px;height: 32px;border:1px solid rgba(246, 211, 211, 0.23);border-radius: 17px;margin-left:12px;font-size: 16px;font-family: Alibaba PuHuiTi;font-weight: 400;color: rgba(229, 127, 127, 1);">
                        待受理
                      </div>
                    </a-col>
                    <a-col span="10" style="font-size: 16px;line-height: 32px;">
                      <img src="../../../assets/img/time.png"
                           style="width:23px;height:23px;margin-right: 9px;user-select: none;"/>预约时间&nbsp;{{
                        item.visitDate
                      }}&nbsp;{{ item.startTime }}-{{ item.endTime }}
                    </a-col>
                    <a-col span="10" style="font-size: 16px;line-height: 32px;">
                      <img src="../../../assets/img/time.png"
                           style="width:23px;height:23px;margin-right: 9px;user-select: none;"/>申请时间&nbsp;{{
                        item.applyTime
                      }}
                    </a-col>
                  </a-row>
                  <a-row style="margin-bottom: 18px;">
                    <a-col span="6">
                      <div style="width: 200px;height: 70px;background: #F5F5E7;border-radius: 8px;">
                        <a-col span="8" style="padding: 5px 8px;">
                          <a-avatar style="background-color: rgb(135, 208, 104);" :size="56" icon="user"/>
                        </a-col>
                        <a-col span="16">
                          <div
                              style="line-height:20px;font-size: 13px;font-family: Alibaba PuHuiTi;font-weight: 300;color: #606060;">
                            发起方
                          </div>
                          <div
                              style="line-height:25px;font-size: 16px;font-family: Alibaba PuHuiTi;font-weight: 300;color: #222222;overflow:hidden; text-overflow:ellipsis; white-space:nowrap;">
                            {{ item.doctor }}&nbsp;<span style="font-size: 14px;">{{ item.department }}</span></div>
                          <div
                              style="line-height:25px;font-size: 14px;font-family: Alibaba PuHuiTi;font-weight: 300;color: #222222;overflow:hidden; text-overflow:ellipsis; white-space:nowrap;">
                            {{ item.organ }}
                          </div>
                        </a-col>
                      </div>
                    </a-col>
                    <a-col span="18">
                      <div style="width: 200px;height: 70px;background: rgba(226, 239, 255, 0.86);border-radius: 8px;">
                        <a-col span="8" style="padding: 5px 8px;">
                          <a-avatar :size="56" :src="doctorAvater"/>
                        </a-col>
                        <a-col span="16">
                          <div
                              style="line-height:20px;font-size: 13px;font-family: Alibaba PuHuiTi;font-weight: 300;color: #606060;">
                            受邀方
                          </div>
                          <div
                              style="line-height:25px;font-size: 16px;font-family: Alibaba PuHuiTi;font-weight: 300;color: #222222;overflow:hidden; text-overflow:ellipsis; white-space:nowrap;">
                            {{ item.expert }}&nbsp;<span style="font-size: 14px;">{{ item.expertDepart }}</span></div>
                          <div
                              style="line-height:25px;font-size: 14px;font-family: Alibaba PuHuiTi;font-weight: 300;color: #222222;overflow:hidden; text-overflow:ellipsis; white-space:nowrap;">
                            {{ item.expertOrgan }}
                          </div>
                        </a-col>
                      </div>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col span="6">
                      <div style="width: 200px;height: 70px;background: #F5F5E7;border-radius: 8px;display: flex;flex-direction: row;align-items: center">
                        <a-col span="8" style="text-align: center;padding: 5px 8px;">
                          <a-avatar style="background-color: #e8e8e8;" :size="56" icon="user"/>
                        </a-col>
                        <a-col span="16">
                          <div
                              style="line-height:20px;font-size: 13px;font-family: Alibaba PuHuiTi;font-weight: 300;color: #606060;">
                            患者
                          </div>
                          <div
                              style="line-height:30px;font-size: 16px;font-family: Alibaba PuHuiTi;font-weight: 300;color: #222222;overflow:hidden; text-overflow:ellipsis; white-space:nowrap;">
                            {{ item.name }}
                          </div>
                        </a-col>
                      </div>
                    </a-col>
                    <a-col span="18">
                      <a-row style="line-height: 25px;color:#999999">
                        <a-col span="5">性别:<span style="font-weight: 300;color:#222222">{{item.sex}}</span></a-col>
                        <a-col span="5">年龄:<span style="font-weight: 300;color:#222222">{{item.age}}</span></a-col>
                        <a-col span="5">孕否:<span style="font-weight: 300;color:#222222">{{item.gestate?'是':'否'}}</span></a-col>
                        <a-col span="9">联系电话:<span style="font-weight: 300;color:#222222">{{item.phone}}</span></a-col>

                      </a-row>
                      <a-row style="line-height: 25px;color:#999999">
                        <a-col>初步诊断:<span style="color:#222222">{{item.diagnostic}}</span></a-col>
                      </a-row>
                    </a-col>
                  </a-row>
                </a-col>
                <a-col span="2" style="text-align: center;background: #F8F8F8;">
                  <div style="background: #F8F8F8;line-height: 32px;">
                    <a href="javascript:;" @click="()=>detailAction(item.id)">详情>></a>
                  </div>
                  <div v-if="(item.status == 'C_ACCEPTED' || item.status == 'D_VISITING')"
                       style="height: 111px;display: inherit;margin-top: 33px;">
                    <img src="../../../assets/img/t-start.png"
                         style="width:78px;height:78px;user-select: none;cursor: pointer;"
                         @click="telemedAction(item.id)"/>
                  </div>
                  <div v-else style="display: block;height: 144px;">
                    <img src="../../../assets/img/t-accept.png"
                         style="width:60px;height:60px;user-select: none;margin-top:6px;margin-bottom: 6px;cursor: pointer;"
                         @click="approveAction(item.id)"/>
                    <img src="../../../assets/img/t-back.png"
                         style="width:60px;height:60px;user-select: none;cursor: pointer;"
                         @click="telemedAction(item.id)"/>
                  </div>
                </a-col>
              </a-row>
            </a-card>
          </template>
        </a-col>
        <a-col :xxl="8" :xl="8" :lg="8" :md="24" :sm="24" :xs="24">
          <a-card size="small" :bordered="false" :body-style="{'padding':'0px'}">
            <a-calendar class="gpws-calendar" :disabled-date="disabledDate" mode="month" @select="scheduleDateSelect"
                        @panelChange="onPanelChange">
              <div slot="dateCellRender" slot-scope="value">
                <div v-if="getTelemedDate(value)">
                  <div style="display:contents;position:absolute; top: 50%; left: 50%;-webkit-transform: translateX(-50%) translateY(-50%);">
                    <div :class="'gpws-telemed-reserve'+(init.visitDate == value.format('YYYY-MM-DD')?' gpws-telemed-reserve-selected':'')">
                      {{ getTelemedDate(value).qty }}
                    </div>
                  </div>
                </div>
              </div>
            </a-calendar>
          </a-card>
          <a-card size="small" :bordered="false"
                  :head-style="{'borderBottom':'none', 'paddingLeft':'24px', 'paddingRight':'24px'}"
                  :body-style="{'padding':'0px'}">
                  <span slot="title" class="gpws-model-title">
                    <img src="../../../assets/img/split.png" style="margin-right: 9px;user-select: none;"/>待受理
                  </span>
            <a-table size="small" :columns="grid.columns" :loading="grid.loading" :rowSelection="{fixed:true}"
                     rowKey="id" :dataSource="grid.data"
                     :scroll="{ x: '100%' }" :pagination="grid.pagination" @change="gridChangeAction">
                    <span slot="index" slot-scope="text, record, index">
                       {{ (((grid.pagination.current - 1) * grid.pagination.pageSize) + index + 1) }}
                    </span>
              <span slot="operate" slot-scope="text, record">
                      <a href="javascript:;" style="margin-right: 10px;" @click="()=>approveAction(record.id)">受理</a>
                      <a href="javascript:;" @click="()=>detailAction(record.id)">详情</a>
                    </span>
            </a-table>
          </a-card>
        </a-col>
      </a-row>
    </a-spin>
    <outpatient-drawer ref="outpatientDrawer"/>
  </div>
</template>

<script>
import doctorAvater from '@/assets/img/doctor-avater.png';
import OutpatientDrawer from '@/components/outpatient/OutpatientDrawer.vue';
import moment from "moment";

export default {
  name: "ReserveOutpatient",
  components: {
    OutpatientDrawer
  },
  data() {
    return {
      loading: false,
      loadTip:'正在获取远程辅诊预约信息,请稍候....',
      current: {},
      timeHandler:undefined,
      doctorAvater: doctorAvater,
      init: {
        currentYear: '',
        currentMonth: '',
        visitDate: ''
      },
      grid: {
        loading: false,
        columns: [{
          title: '序号',
          align: 'center',
          scopedSlots: {customRender: 'index'},
          width: 60
        },
          {
            title: '姓名',
            dataIndex: 'name',
            key: 'name',
            width: 100,
            customRender: (text, record, index) => {
              return text == null || text == undefined || text == '' ? '-' : text;
            }
          }, {
            title: '预约时间',
            key: 'visitTime',
            customRender: (text, record, index) => {
              return record.visitDate + ' ' + record.startTime + '-' + record.endTime;
            }
          },
          {
            title: '操作',
            key: 'operate',
            width: 100,
            scopedSlots: {customRender: 'operate'}
          }],
        data: [],
        pagination: {
          current: 1,
          total: 0,
          pageSize: 10,
          defaultPageSize: 10,
          showQuickJumper: false,
          showSizeChanger: false,
          showTotal: function (total, range) {
            return '当前显示第' + range[0] + '-' + range[1] + '条, 共 ' + total + ' 条数据';
          }
        }
      },
      reserves: [],
      records: []
    }
  },
  beforeCreate() {
    let data = [{
      text: "首页",
      path: ""
    }, {
      text: "远程辅诊",
      path: ""
    }, {
      text: "辅诊预约",
      path: ""
    }];
    this.$store.commit('updateBreadcrumb', data);
  },
  mounted() {
    this.current = JSON.parse(localStorage.getItem("curruser"));
    this.init.visitDate = this.getCurrDate(new Date());
    this.refreshAction();
  },
  beforeDestroy() {
    if(this.timeHandler){
      window.clearInterval(this.timeHandler);
    }
  },
  methods: {
    refreshAction:function (){
      this.timeActionHandler();
      if(this.timeHandler){
        window.clearInterval(this.timeHandler);
      }
      this.timeHandler = window.setInterval(this.timeActionHandler, 120000);
    },
    clearTimeHandler:function (){
      if(this.timeHandler){
        window.clearInterval(this.timeHandler);
      }
    },
    timeActionHandler:function (){
      this.loadReserveGather();
      this.loadOutpatients();
      this.searchAction();
    },
    getTelemedDate: function (value) {
      if (value && value < moment().subtract(1, 'days').endOf('day')) {
        return null;
      }
      if (undefined == this.reserves || null == this.reserves || this.reserves.length <= 0) {
        return null;
      }
      let reserves = this.reserves.filter(m => m.visitDate == value.format('YYYY-MM-DD'));
      if (reserves.length > 0) {
        return reserves[0];
      }
      return null;
    },
    onPanelChange: function (value) {
      this.init.currentYear = value.year();
      this.init.currentMonth = value.month() + 1;
      this.loadReserveGather();
    },
    disabledDate: function (current) {
      return current && current < moment().subtract(1, 'days').endOf('day');
    },
    scheduleDateSelect: function (value) {
      this.init.visitDate = value.format('YYYY-MM-DD');
      this.loadOutpatients();
    },
    loadReserveGather: function () {
      const self = this;
      this.loading = true;
      this.loadTip = '正在获取远程辅诊预约信息,请稍候....';
      this.reserves = [];
      this.$axios.get('/api/clinic/telemed/' + this.current.organId + '/reserve/gather',
          {params: {reserveYear: this.init.currentYear, reserveMonth: this.init.currentMonth}}).then(function (res) {
        self.loading = false;
        if (res.msg.flag == 0) {
          if (null != res.biz && !res.biz.empty) {
            self.reserves = res.biz;
          }
        } else {
          self.$message.error({content: res.msg.message, duration: 2});
        }
      }, function () {
        self.loading = false;
      });
    },
    telemedAction: function (id) {
      this.$router.push({path: '/telemed/room', query: {id: id}});
    },
    approveAction: function (id) {
      const self = this;
      this.loading = true;
      this.loadTip = '正在受理远程辅诊预约,请稍候....';
      this.$axios.post('/api/clinic/telemed/' + id + '/accept').then(function (res) {
        self.loading = false;
        if (res.msg.flag == 0) {
          self.$message.success({content: '远程辅诊预约受理成功.', duration: 2});
          self.loadOutpatients();
          self.searchAction();
        } else {
          self.$message.error({content: res.msg.message, duration: 2});
        }
      }, function (res) {
        self.loading = false;
      });
    },
    detailAction: function (id) {
      this.$refs.outpatientDrawer.showAction(id);
    },
    /**
     * 查询
     */
    loadOutpatients: function () {
      const self = this;
      this.loading = true;
      this.loadTip = '正在获取远程辅诊预约信息,请稍候....';
      this.records = [];
      this.$axios.get('/api/clinic/telemed/' + this.current.organId + '/reserve/outpatients', {params: {visitDate: this.init.visitDate}}).then(function (res) {
        self.loading = false;
        if (res.msg.flag == 0) {
          if (null != res.biz && !res.biz.empty) {
            self.records = res.biz;
            if(self.records.filter(e=>e.status == 'B_PAID').length > 0){
              let voice = document.getElementById("voice");
              voice.currentTime = 0;
              voice.play();
            }
          }
        } else {
          self.$message.error({content: res.msg.message, duration: 2});
        }
      }, function () {
        self.loading = false;
      });
    },
    buildParams: function () {
      return {
        'entity.status': 'B_PAID', 'entity.expertId': this.current.doctorId, 'entity.organId': this.current.organId
      };
    },
    /**
     * 查询按钮动作
     */
    searchAction: function () {
      Object.assign(this.grid, {pagination: Object.assign(this.grid.pagination, {current: 1})});
      let params = Object.assign(this.buildParams(), {start: 0, length: this.grid.pagination.pageSize});
      this.loadGrid(params);
    },
    /**
     * 分页条操作
     */
    gridChangeAction: function (pagination, filters, sorter) {
      Object.assign(this.grid, {pagination: pagination});
      let params = Object.assign(this.buildParams(), {
        start: (pagination.current - 1) * pagination.pageSize,
        length: pagination.pageSize
      });
      this.loadGrid(params);
    },
    /**
     * 查询
     */
    loadGrid: function (params) {
      const self = this;
      self.grid.loading = true;
      self.$axios.get('/api/clinic/telemed/reserve/outpatients', {params: params}).then(function (res) {
        self.grid.loading = false;
        if (res.msg.flag == 0) {
          if (null == res.biz || res.biz.empty) {
            Object.assign(self.grid, {data: [], pagination: Object.assign(self.grid.pagination, {total: 0})});
          } else {
            Object.assign(self.grid, {
              data: res.biz.data,
              pagination: Object.assign(self.grid.pagination, {total: res.biz.count})
            });
          }
        } else {
          self.$message.error({content: res.msg.message, duration: 2});
        }
      }, function () {
        self.grid.loading = false;
      });
    }
  }
}
</script>

<style scoped>
.gpws-telemed-reserve {
  margin: 4px 6px;
  height: 18px;
  line-height: 18px;
  background: rgba(95, 192, 33, 1);
  border-radius: 4px;
  font-size: 13px;
  font-family: Alibaba PuHuiTi;
  font-weight: 500;
  text-align: center;
  color: #D02F2F;
}

.gpws-telemed-reserve-selected {
  background: rgba(252, 240, 240, 0.2);
  color: #ffffff;
}
</style>
